import type { MaybeRef } from 'vue';

import { formatDate } from '@experience/datetime-utils';

import { DEFAULT_FILTER_TITLE } from '../const/config';
import { parseLocalDate } from './localDate';

const normalizeMonthName = (month: string) => {
  if (month.includes('ию')) {
    return month;
  }

  return month.slice(0, 3);
};

export function dateToTitle(dateRaw: string | null) {
  if (!dateRaw) {
    return null;
  }

  const date = formatDate(parseLocalDate(dateRaw), 'd MMMM');

  const day = date.split(' ')[0];
  const month = normalizeMonthName(date.split(' ')[1]);

  return {
    date,
    day,
    month,
  };
}

export function getFilterDate(dateFrom: string | null, dateTo: string | null) {
  const from = dateToTitle(dateFrom);
  const to = dateToTitle(dateTo);

  if (from && !to) {
    return `${from.day} ${from.month}`;
  } else if (!from || !to) {
    return DEFAULT_FILTER_TITLE;
  }

  if (from.date !== to.date) {
    return from.month !== to.month
      ? `${from.day} ${from.month} — ${to.day} ${to.month}`
      : `${from.day}–${to.day} ${to.month}`;
  } else {
    return `${from.day} ${from.month}`;
  }
}

export function getFilterTitle(dateFrom: string | null, dateTo: string | null, personsCount?: MaybeRef<number>) {
  const dateLabel = getFilterDate(dateFrom, dateTo);

  return personsCount ? `${dateLabel}, ${unref(personsCount)} чел.` : `${dateLabel}`;
}
